(function (root, factory) {
  const money = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = money;
  }

  if (root) {
    root.HOMTheme = root.HOMTheme || {};
    root.HOMTheme.money = money;
    root.Shopify = root.Shopify || {};
    root.Shopify.money_format = root.Shopify.money_format || '${{amount}}';
    root.Shopify.formatMoney = money.format;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  const PLACEHOLDER_PATTERN = /\{\{\s*(\w+)\s*\}\}/;
  const FORMAT_OPTIONS = Object.freeze({
    amount: { thousands: ',', decimal: '.' },
    amount_no_decimals: { thousands: ',', decimal: '.' },
    amount_with_comma_separator: { thousands: '.', decimal: ',' },
    amount_no_decimals_with_comma_separator: { thousands: '.', decimal: ',' },
    amount_with_space_separator: { thousands: ' ', decimal: ',' },
    amount_no_decimals_with_space_separator: { thousands: ' ', decimal: '.' },
    amount_with_apostrophe_separator: { thousands: "'", decimal: '.' }
  });

  function normalizeCents(cents) {
    return typeof cents === 'string' ? cents.replace('.', '') : cents;
  }

  function formatWholeAmount(cents, options) {
    const numericCents = Number(normalizeCents(cents));
    if (!Number.isFinite(numericCents)) return '0';

    const roundedAmount = (numericCents / 100).toFixed(0);
    return roundedAmount.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${options.thousands}`);
  }

  function format(cents, formatTemplate) {
    const template = formatTemplate || this?.money_format || '${{amount}}';
    const placeholder = template.match(PLACEHOLDER_PATTERN);
    if (!placeholder) return template;

    const options = FORMAT_OPTIONS[placeholder[1]] || FORMAT_OPTIONS.amount;
    return template.replace(PLACEHOLDER_PATTERN, formatWholeAmount(cents, options));
  }

  return Object.freeze({ format, formatWholeAmount, normalizeCents });
});
